<template>
  <div>
    <div v-if="!isPrint">
      <el-button type="primary" style="margin-bottom:5px" @click="printPage">打印</el-button>
    </div>
    <div id="printContent">
      <table class="table">
        <tr>
          <td>
            收货单位:
            <span style="margin-left:30px">建发，浅水湾随行电缆</span>
          </td>
          <td rowspan="2" style="border-bottom:none;width: 300px;">
            条码号:700717341
          </td>
        </tr>
        <tr>
          <td style="border-bottom:none">
            <span>客户合同号: 123456789</span>
            <span style="margin-left:200px">设备号/工号：123456789</span>
          </td>
        </tr>
      </table>
      <table class="table">
        <tr>
          <td>合同号:</td>
          <td>CF/D210805-1</td>
          <td>箱号:</td>
          <td>123456789</td>
          <td rowspan="2" style="width: 20px;border-bottom:none">梯号：</td>
          <td rowspan="2" style="border-bottom:none">123456</td>
        </tr>
        <tr>
          <td style="border-bottom:none">外形尺寸:</td>
          <td style="border-bottom:none">1850*700*610</td>
          <td style="border-bottom:none">毛重:</td>
          <td style="border-bottom:none">123456</td>
        </tr>
      </table>
      <table class="table">
        <tr>
          <td>产品描述</td>
          <td>技术参数</td>
          <td>数量</td>
        </tr>
        <tr>
          <td style="width: 290px;">1</td>
          <td>1</td>
          <td>1套</td>
        </tr>
        <tr style="width: 290px;">
          <td>电缆线</td>
          <td>1</td>
          <td>1台</td>
        </tr>
        <tr style="width: 290px;">
          <td>1</td>
          <td>1</td>
          <td>1台</td>
        </tr>
      </table>
      <div style="width:900px;height:120px;display:inline-block;margin-top:5px">
        <span style="float:left;margin-left:40px">
          <img style="width:150px" src="../../../public/img/SCFSIcon.png">
        </span>
        <span style="float:left">
          <img style="width:600px" src="../../../public/img/SCFSLabel.png">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isPrint:false,
      };
    },
    methods:{
      printPage() {
        this.isPrint = true;
        this.$nextTick(()=>{
          document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
          window.print();
          window.location.reload();
          this.isPrint = false;
          return false;
        });
       
      },
    },
  };
</script>

<style lang="scss" scoped>
.table{
  margin: 0;
  width: 900px;
  border-collapse: collapse;
}
.table td{
  border: 1px solid #333;
  margin: 0;
  padding: 10px;
}
</style>